export default __webpack_public_path__ + "static/media/1v1_gold_bg.84b707ee.png";